import React, { useState, useEffect } from 'react';
import therapies from './theraphy.json';
import './Theraphy.css';

function Therapy() {
  const [selectedId, setSelectedId] = useState('');
  const therapy = therapies.find(t => t.id === selectedId);

  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length === 0) {
        setTimeout(loadVoices, 100);
      }
    };
    loadVoices();
  }, []);

  const speak = (text, langCode) => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();

    // Match voice by language code
    const voice = voices.find(v => v.lang === langCode);

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = langCode;
    if (voice) utterance.voice = voice;

    synth.speak(utterance);
  };

  return (
    <div className="app">
      <h1>💆 Therapy Guide</h1>
      <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
        <option value="">Select a therapy</option>
        {therapies.map(t => (
          <option key={t.id} value={t.id}>{t.title}</option>
        ))}
      </select>

      {therapy && (
        <div className="therapy-container">
          {/* English */}
                    <div> <h1><u>In English</u></h1></div>

          <div className="language-block">
            <h2>{therapy.title}</h2>
            {therapy.english.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{therapy.english.moralHeading}</h3>
            <p>{therapy.english.moral}</p>

            <button onClick={() => speak([...therapy.english.lines, therapy.english.moral].join(' '), 'en-US')}>
              🔊 Read Aloud (English)
            </button>
          </div>

          {/* Hindi */}
          <div> <h1><u>In Hindi</u></h1></div>
          <div className="language-block">
            <h2>{therapy.hindi.title}</h2>
            {therapy.hindi.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{therapy.hindi.moralHeading}</h3>
            <p>{therapy.hindi.moral}</p>
            <button onClick={() => speak([...therapy.hindi.lines, therapy.hindi.moral].join(' '), 'hi-IN')}>
              🔊 Read Aloud (Hindi)
            </button>
          </div>

          {/* Telugu */}
          <div> <h1><u>In Telugu</u></h1></div>
          <div className="language-block">
            <h2>{therapy.telugu.title}</h2>
            {therapy.telugu.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{therapy.telugu.moralHeading}</h3>
            <p>{therapy.telugu.moral}</p>

            <button onClick={() => speak([...therapy.telugu.lines, therapy.telugu.moral].join(' '), 'te-IN')}>
              🔊 Read Aloud (Telugu)
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Therapy;
